import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

import store from "@/store";

import error from "@/pages/error.vue";
import login from "@/pages/login/index.vue";
import loginReset from "@/pages/login/reset.vue";

import rma from "@/pages/rma/index.vue";
import index from "@/pages/index/index.vue";
import order from "@/pages/order/index.vue";
import library from "@/pages/library/index.vue";
import profile from "@/pages/profile/index.vue";
import contact from "@/pages/contact/index.vue";

const routes = [
	{path: "/", name: "index", component: index, meta: {layout: "main", title: "Forside"}},
	{path: "/login", name: "login", component: login, meta: {auth: false}},
	{path: "/login/reset/:id", name: "login-reset", component: loginReset, meta: {auth: false}},
	{path: "/library", name: "library", component: library,  meta: {layout: "main", title: "Bibliotek"}},
	{path: "/profile", name: "profile", component: profile,  meta: {layout: "main", title: "Profil"}},
	{path: "/contact", name: "contact", component: contact,  meta: {layout: "main", title: "Kontakt"}},
	{path: "/order", name: "order", component: order,  meta: {layout: "main", title: "Bestillingsliste"}},
	{path: "/complaint", name: "rma", component: rma, meta: {layout: "main", title: "Reklamation"}},


	{path: "/error", alias: "*", name: "error", props: true, component: error, meta: {auth: false, title: "Error"}}
];

const router = new Router({
	routes,
	mode: "history",
	base: process.env.BASE_URL,
	scrollBehavior (to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			return {x: 0, y: 0}
		}
	}
});


const go = ({to, next}) => {
	if (to.meta.title) store.dispatch("base/meta", {title: to.meta.title});
	next();
};

router.beforeEach(async (to, from, next) => {
	const user = store.getters["user/data"] || await store.dispatch("user/data");

	// redirect to home if already logged in on login page
	if (user && to.name === "login") return next("/");

	// allow all routes that isn't protected by auth
	if (to.meta.auth === false) return go({to, next});

	// if no user, logout
	if (!user) return store.dispatch("user/logout");

	go({to, next});
});

export default router;
